export class TreasuryWalletRequestContractError extends Error {
  constructor(operation) {
    super(`Invalid Treasury wallet ${operation} request.`);
    this.name = 'TreasuryWalletRequestContractError';
    this.code = 'INVALID_API_REQUEST';
  }
}

const isRecord = value => value !== null && typeof value === 'object' && !Array.isArray(value);
const isText = value => value === null || typeof value === 'string';
const nonemptyText = value => typeof value === 'string' && value.trim().length > 0;
const walletFields = ['label', 'tokenSymbol', 'watchOnly', 'isActive', 'explorerUrl', 'donationConfig'];
const donationFields = ['isDefaultDestination', 'isAcceptingContributions', 'visibility', 'destinationLabel', 'instructions', 'qrCodeUrl', 'referenceHint'];
const donationTextFields = ['destinationLabel', 'instructions', 'qrCodeUrl', 'referenceHint'];

const validDonationConfig = value => isRecord(value)
  && donationFields.some(field => field in value)
  && ['isDefaultDestination', 'isAcceptingContributions'].every(field => value[field] === undefined || typeof value[field] === 'boolean')
  && (value.visibility === undefined || typeof value.visibility === 'string' && ['internal', 'community', 'public'].includes(value.visibility.trim()))
  && donationTextFields.every(field => value[field] === undefined || isText(value[field]));

const validOptionalFields = payload => ['watchOnly', 'isActive'].every(field => payload[field] === undefined || typeof payload[field] === 'boolean')
  && ['tokenSymbol', 'explorerUrl'].every(field => payload[field] === undefined || isText(payload[field]))
  && (payload.donationConfig === undefined || validDonationConfig(payload.donationConfig));

export function readTreasuryWalletCreateRequest(payload) {
  if (!isRecord(payload) || !nonemptyText(payload.chain) || !nonemptyText(payload.address)
    || !nonemptyText(payload.label) || !validOptionalFields(payload)) {
    throw new TreasuryWalletRequestContractError('create');
  }
  return payload;
}

export function readTreasuryWalletUpdateRequest(payload) {
  if (!isRecord(payload) || !walletFields.some(field => field in payload)
    || (payload.label !== undefined && !nonemptyText(payload.label))
    || !validOptionalFields(payload)) {
    throw new TreasuryWalletRequestContractError('update');
  }
  return payload;
}

export function readTreasuryWalletIdentifier(value) {
  if (typeof value !== 'string' || !/^[a-f0-9]{24}$/i.test(value)) throw new TreasuryWalletRequestContractError('identifier');
  return value;
}
